export default __webpack_public_path__ + "static/mm-50e800c4bd453f345a39888b68224a2e.svg";